import React from "react";
import { Quote } from "lucide-react";
import { ASSETS } from "@/lib/brand";

export const PlushVision = () => {
  return (
    <section
      id="vision"
      data-testid="plush-vision-section"
      className="relative py-24 sm:py-32 bg-paula-ink text-white overflow-hidden"
    >
      {/* subtle glow */}
      <div
        aria-hidden
        className="absolute -top-32 left-1/3 w-[600px] h-[600px] rounded-full bg-paula-red/20 blur-[120px]"
      />
      <div
        aria-hidden
        className="absolute bottom-0 right-0 w-[420px] h-[420px] rounded-full bg-paula-blue/25 blur-[100px]"
      />

      <div className="relative max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-6">
          <div className="text-xs font-semibold uppercase tracking-[0.2em] text-paula-yellow mb-5">
            Die Vision
          </div>
          <h2 className="font-display font-bold text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight">
            Plüsch-Paula in jedem{" "}
            <span className="text-paula-yellow">Rettungswagen</span>.
          </h2>

          <div className="mt-10 relative pl-8 border-l-2 border-paula-yellow">
            <Quote
              className="absolute -left-4 -top-2 text-paula-yellow bg-paula-ink"
              size={28}
              strokeWidth={2.5}
            />
            <p className="font-display italic text-2xl sm:text-3xl text-white leading-snug">
              „Paula wird von jedem RTW aus an ängstliche Kinderhände gereicht."
            </p>
            <footer className="mt-4 text-sm text-white/60 uppercase tracking-widest">
              — Unsere Vision
            </footer>
          </div>

          <p className="mt-10 text-white/80 text-lg leading-relaxed max-w-xl">
            Stell Dir vor: Ein Kind hat Angst. Sirenen, fremde Menschen, alles
            zu schnell. Und dann — eine kleine Pinguindame in seiner Hand.
            Plötzlich ist da Wärme. Halt. Mut. Das ist unsere Vision.
          </p>

          <div className="mt-10 flex flex-wrap gap-3">
            <a
              href="#foerderer"
              data-testid="vision-cta-support"
              className="inline-flex items-center px-6 py-3 rounded-full bg-paula-yellow text-paula-ink font-semibold hover:bg-white transition-colors"
            >
              Vision unterstützen
            </a>
            <a
              href="#schulen"
              data-testid="vision-cta-schools"
              className="inline-flex items-center px-6 py-3 rounded-full border border-white/30 text-white font-semibold hover:bg-white/10 transition-colors"
            >
              Für Schulen
            </a>
          </div>
        </div>

        <div className="lg:col-span-6">
          <div className="relative rounded-3xl overflow-hidden border border-white/10 shadow-2xl bg-white">
            <img
              src={ASSETS.plushPaula}
              alt="Plüsch-Paula in der Hand"
              className="w-full h-[480px] object-cover"
              data-testid="plush-paula-image"
            />
            <div className="absolute inset-x-0 bottom-0 p-5 bg-gradient-to-t from-paula-ink/85 to-transparent">
              <div className="flex items-center justify-between">
                <div className="bg-white/95 backdrop-blur rounded-2xl px-4 py-3">
                  <div className="text-[10px] uppercase tracking-widest text-paula-muted">
                    Im Einsatz
                  </div>
                  <div className="font-display font-semibold text-paula-ink">
                    Plüsch-Paula
                  </div>
                </div>
                <div className="bg-paula-red rounded-2xl px-4 py-3 text-white">
                  <div className="text-[10px] uppercase tracking-widest opacity-80">
                    Ziel
                  </div>
                  <div className="font-display font-semibold">
                    Jeder RTW. Bundesweit.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PlushVision;
